import React from "react";
import { Row, Col } from "react-bootstrap";
import { toNorwegianDatetime, toNorwegianDateFormat } from "../../utils/date";
import { capitalizeWords } from "../../utils/stringUtils";

function ArkivInfoColumn({ property, label, required = false }) {
  return (
    <Col xl={6}>
      <div className="klageinfo-label">{label}</div>
      <div
        className={
          required && !property
            ? "klageinfo-text text-danger"
            : "klageinfo-text"
        }
      >
        {property ? property : required ? "*Mangler info fra arkivsystem" : "-"}
      </div>
    </Col>
  );
}

const KlageInfoDetail = ({ sak }) => {
  const klageInfo = sak && sak.kontakt;
  return (
    <div className="klageinfo">
      <div className="klageinfo-row">
        <Row>
          <ArkivInfoColumn
            property={klageInfo && klageInfo.navn}
            label="Klager"
            required
          />
          <ArkivInfoColumn
            property={klageInfo && capitalizeWords(klageInfo.adresse)}
            label="Adresse"
          />
        </Row>
      </div>
      <div className="klageinfo-row">
        <Row>
          <ArkivInfoColumn
            property={klageInfo && klageInfo.postnummer}
            label="Postnr."
            required
          />
          <ArkivInfoColumn
            property={klageInfo && klageInfo.poststed}
            label="Poststed"
            required
          />
        </Row>
      </div>
      <div className="klageinfo-row">
        <Row>
          <ArkivInfoColumn
            property={klageInfo && klageInfo.land}
            label="Land"
          />
          <ArkivInfoColumn
            property={klageInfo && klageInfo.epost}
            label="Epost"
          />
        </Row>
      </div>
      <div className="klageinfo-row">
        <Row>
          <ArkivInfoColumn
            property={
              sak &&
              toNorwegianDateFormat(toNorwegianDatetime(sak.opprettetDato))
            }
            label="Opprettet dato"
          />
          <ArkivInfoColumn
            property={
              sak && toNorwegianDateFormat(toNorwegianDatetime(sak.dato))
            }
            label="Ferdig dato"
          />
        </Row>
      </div>
    </div>
  );
};

export default KlageInfoDetail;
